import { useEffect, useState } from 'react';
import { Pie } from '@ant-design/plots';
import { formatarReal } from '../functions/funcoes';
import { iCompromisso } from '../interfaces/iFinanceiro';
import { Flex, Row, Col, Typography } from 'antd';
import { getHeight } from '../functions/funcoes';
import { Azul, Financeiro, FinanceiroZerado, Vermelho } from '../constants/Cores';

const { Text } = Typography;

const CtCompromisso = () => {
  const [dados, setDados] = useState<iCompromisso[]>([]);

  function getAltura() {
    let AAltura = {
      A1920xL1080: 158,
      A1680xL1050: 158,
      A1600xL900: 128,
      A1440xL900: 128,
      A1400xL1050: 105,
      A1366xL768: 117,
      A1280xL1024: 105,
      A1280xL960: 105,
      A1280xL800: 95,
      A1280xL768: 95,
      A1280xL720: 95,
      A1280xL600: 95,
      A1152xL864: 95,
      A1024xL768: 95,
      A800xL600: 95,
    };

    return getHeight(AAltura);
  }

  useEffect(() => {
    window.addEventListener('compromissosDelphi', (event: any) => {
      const dadosRecebidos = event.detail;
      setDados(dadosRecebidos);
    });
  }, []);

  const total = dados.reduce((total, d) => total + d.valor, 0);
  const totalRec = dados.reduce((total, d) => d.name === 'Receber' ? total + d.valor : total, 0);
  const totalPag = dados.reduce((total, d) => d.name === 'Pagar' ? total + d.valor : total, 0);
  function Cores() {
    if (total === 0) {
      return FinanceiroZerado
    }
    return Financeiro
  }

  function CoresLinha(i: number) {
    if (dados[i].name === 'Receber' && dados[i].valor != 0) {
      return Azul
    } else if (dados[i].name === 'Pagar' && dados[i].valor != 0) {
      return Vermelho
    }
    return
  }

  const config = {
    data: dados,
    angleField: 'qtde',
    colorField: 'name',
    legend: false,
    height: getAltura(),
    innerRadius: 0.6,
    autoFit: true,
    autoResize: true,
    labels: [
      {
        text: (d: iCompromisso, i: number, data: iCompromisso[]) => {
          let total = dados.reduce((total, d) => total + d.qtde, 0);
          // Se total é maior que zero, significa que receber e/ou pagar possuem registros
          if (total > 0) {
            if (dados[i].qtde != 0) {
              return dados[i].qtde
            }
            return ''
          }
          // Quando nenhum dos dois possuem registros mostra a qtde 0 em ambos
          return dados[i].qtde
        },
        style: { fontSize: 12, fontWeight: 'bold', fill: 'black' },
        position: 'inside'
      }
    ],
    style: {
      stroke: (d: iCompromisso, i: number, data: iCompromisso[]) => (CoresLinha(i)),
      inset: 5,
      radius: 10,
    },
    tooltip: false,
    scale: {
      color: {
        palette: Cores(),
        offset: (t: number) => t * 0.8 + 0.1,
      },
    },
  };
  return (
    <>
      <Pie {...config} />
      <Row
        justify={'space-around'}>
        <Col>
          <Flex justify='space-around' align='center' vertical>
            <span>Contas a receber</span>
            <Text
              style={{ fontWeight: 700 }}
              type="success">{formatarReal(totalRec)}</Text>
          </Flex>
        </Col>
        <Col>
          <Flex justify='space-around' align='center' vertical>
            <span>Contas a pagar</span>
            <Text
              style={{ fontWeight: 700 }}
              type="danger">{formatarReal(totalPag)}</Text>
          </Flex>
        </Col>
      </Row>
    </>
  )

};

export default CtCompromisso;